export default __webpack_public_path__ + "static/media/action.2db69ab1.png";